import { defineComponent as _defineComponent } from 'vue'
import LoadingIndicator from "@/components/loaders/LoadingIndicator.vue";
import {computed} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PayoutFormPreloader',
  props: {
  height: {
    type: String,
    default: '60px'
  },
  alignCenter: {
    default: true,
    type: Boolean
  }
},
  setup(__props) {

const props = __props;



const liClass = computed(() => {
  return props.alignCenter ? ['li--align-center'] : [];
})

return { __sfc: true,props, liClass, LoadingIndicator, computed }
}

})